var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container",style:(_vm.styleObject)},[_c('i',{staticClass:"icon-spinner",style:({ 'font-size': _vm.fontSize })})])
}
var staticRenderFns = []

export { render, staticRenderFns }